import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeModule } from './home/home.module';
import { ReclamacionesModule } from './reclamaciones/reclamaciones.module';
import { AboutModule } from './about/about.module';
import { SolutionModule } from './solution/solution.module';
import { BlogModule } from './blog/blog.module';
import { ContactModule } from './contact/contact.module';
import { ProjectsModule } from './projects/projects.module';
import { AmbientalTareaDeTodosModule } from './ambiental-tarea-de-todos/ambiental-tarea-de-todos.component.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HomeModule,
    ReclamacionesModule,
    AboutModule,
    SolutionModule,
    BlogModule,
    AmbientalTareaDeTodosModule,
    ContactModule,
    ProjectsModule
  ],
  exports: [
    HomeModule,
    ReclamacionesModule,
    AboutModule,
    SolutionModule,
    BlogModule,
    ContactModule,
    ProjectsModule
  ]
})
export class PagesModule { }
